import {put, takeLatest, call} from 'redux-saga/effects';
import * as promotionService from "../../../../services/promotionService.js";
import {
    DELETE_PROMOTION,
    DELETE_PROMOTION_SUCCESS,
    DELETE_PROMOTION_ERROR
}
    from "../../../actions/menu/promotions";

function* deletePromotionSaga(action) {
    try {
        yield call(promotionService.DeletePromotion, action.payload)
        yield put({
            type: DELETE_PROMOTION_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: DELETE_PROMOTION_ERROR,error: error.data
        });
    }
}


export function* deletePromotionSagaWatcher() {
    yield takeLatest(DELETE_PROMOTION, deletePromotionSaga);
}